import { CustomRoutes, customRoutes } from 'config/route';

function useRoute<Name extends keyof CustomRoutes>(name: Name): CustomRoutes[Name] {
  return customRoutes[name];
}

export { useRoute };
